import { render, staticRenderFns } from "./BaseInfoDay.vue?vue&type=template&id=70e96962"
import script from "./BaseInfoDay.vue?vue&type=script&lang=js"
export * from "./BaseInfoDay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports